import React, { useEffect, useRef, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, Report, IReportEmbedConfiguration } from "powerbi-client";
import { postMethodThirdParty, ApiEndPoint } from "../../services";
import "./PowerBiReport.scss";
import environment from "environment";
import { POWERBI_DETAILAED_REPORT_NAME, POWERBI_DETAILAED_REPORT_PREFIX, defaultVariable, useStyles } from "common";
import { useDispatch, useSelector } from "react-redux";
import { setPowerBiReportPage } from "redux/actions/powerBiReportPageAction"
import SkeletonDashboardReport from "components/skeletonDashboardReport";

interface Props {
    userRole: string,
    reportName?: string,
    filterValues: any
}

const PowerBiReport = ({ userRole = '', reportName = '', filterValues = null } : Props) => {
    // 
    const trialBannerHeight = 40;
    const ref = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);
    const [loadingPage, setLoadingPage] = useState(true);
    const [report, setReport] = useState<Report>();
    const classes = useStyles();
    const dispatch = useDispatch();
    const powerBiReportPage = useSelector((state: any) => state.powerBiReportPage);
    const refreshTimer: any = useRef();
    const analyticsReportsNames: any = environment?.powerBiAnalyticsReportsName;
    const powerBiStationUsageReportsName: any = environment?.powerBiStationUsageReportsName;

    const reportConfigDefaults = {
        type: "report",
        embedUrl: '',
        accessToken: '',
        tokenType: models?.TokenType.Embed,
        pageName: (reportName === 'stationusage') ? powerBiStationUsageReportsName?.[reportName] : analyticsReportsNames?.[reportName],
        settings: {
            layoutType: models?.LayoutType.Custom,
            background: models?.BackgroundType.Transparent,
            customLayout: {
                displayOption: models?.DisplayOption.FitToWidth,
            },
            bars: {
                statusBar: {
                    visible: false,
                },
            },
            panes: {
                filters: {
                    expanded: false,
                    visible: false,
                },
                pageNavigation: {
                    visible: false,
                },
            },
        },
    }

    const reportId =
        (reportName === "stationusage")
            ? environment.powerBiStationUsageReportId
            : environment.powerBiAnalyticsReportId;
    const tokenRequestBody = {
        tenantId: environment.powerBiTenantId,
        groupId: environment.powerBiGroupId,
        reportId: reportId,
    };

    const [reportConfig, setReportConfig] = useState<IReportEmbedConfiguration>(reportConfigDefaults);

    const [pageAspectRatio, setPageAspectRatio] = useState(0.5);

    function checkTokenAndUpdate() {
        // Get the current time
        const currentTime = Date.now();
        const expiration = Date.parse(sessionStorage.getItem(defaultVariable.POWERBI_EXPIRY_EPOC)!);

        // Time until token expiration in milliseconds
        const timeUntilExpiration = expiration - currentTime;
        const timeToUpdate = defaultVariable.POWERBI_MINUTES_BEFORE_EXPIRATION;
        // Update the token if it is about to expired
        if (timeUntilExpiration <= timeToUpdate)
        {
            // 
            updateToken();
        }
    }

    async function updateToken() {
        postMethodThirdParty(ApiEndPoint.powerBiAccessToken, '', tokenRequestBody)
            .then(async (res:any) => {
                if (res.status === 200) {
                    if (res.data) {
                        // Set the new access token
                        sessionStorage.setItem(defaultVariable.POWERBI_EXPIRY_EPOC, res.data?.expiration?.toString());
                        const embedUrl: string = res.data?.value?.find((rId:any) => rId.id === reportId)?.embedUrl || "";
                        setReportConfig({
                            ...reportConfigDefaults,
                            embedUrl: embedUrl,
                            accessToken: res.data?.token,
                        });
                    }
                }})
    }

    const getAspectRatio = (pageName: string) => {
        let ratio = 0.5;
        try {
            const dim = pageName.split('#')[1].trim()
            const [w, h] = dim.split('x')
            ratio = Math.floor(Number(w) / Number(h) * 100) / 100;
        }
        catch {
            // 
        }
        return ratio;
    }

    // const getVisualFilterParams = (filterName: string, reportTitle: string, detailPageTitle: string, isDetailedReport: boolean) => {
    //     const reportKey =  reportTitle.replace(/ /g,'').toLowerCase();
    //     const detailKey = detailPageTitle.replace(/ /g,'').toLowerCase();
    //     let tabObj;
    //     // 
    //     return {
    //         table: defaultVariable.powerBiReportFiltersMap?.[reportKey]?.,
    //         column: tabObj?.column
    //     }
    // }

    const applyVisualFilters = async (page: any, visualset: any) => {
        // 
        const allVisuals = await page.getVisuals();
        // 
        
        
        visualset?.forEach((v:any) => {
            
            
            v.visuals.forEach(async (vItem:any) => {
                
                

                Object.keys(defaultVariable.powerBiCommonFiltersMap)
                .filter((key: any) => filterValues?.[defaultVariable.powerBiCommonFiltersMap[key]]?.length)
                .forEach(async (validObj: any) => { //Filters without any values won't be passed
                    
                    // 
                    const filterTarget = v.filters[validObj];
                    
                    if (!filterTarget) return;
                    const filter: models.IBasicFilter = {
                        $schema: "https://powerbi.com/product/schema#basic",
                        filterType: models?.FilterType?.Basic,
                        target: {
                            table: filterTarget?.table,
                            column: filterTarget?.column
                        },
                        operator: "In",
                        values: filterValues?.[defaultVariable.powerBiCommonFiltersMap[validObj]] || [],
                    };
                    let vObj = allVisuals.filter((vDesc: any) => vDesc.title === vItem)[0];
                    
                    
                    await vObj.updateFilters(models.FiltersOperations.Add, [filter]);
                })
                // // 
            })
        })
    }

    const getFilterParams = (page: any, filterName: string, reportTitle: string, detailPageTitle: string, isDetailedReport: boolean) => {
        const reportKey =  reportTitle.replace(/ /g,'').toLowerCase();
        const detailKey = detailPageTitle.replace(/ /g,'').toLowerCase();
        
        let tabObj;
        if (reportTitle === 'stationusage' && isDetailedReport) {
            tabObj = defaultVariable.powerBiReportFiltersMap?.[reportKey]?.detail?.[detailKey]?.[filterName];
        }
        else if (reportTitle === 'stationusage')
            //Apply Visual Filters
            applyVisualFilters(page, defaultVariable.powerBiReportFiltersMap?.[reportKey]?.visualset)
        else
            //Other than stationusage and their detailed reports
            tabObj = defaultVariable.powerBiReportFiltersMap?.[reportKey]?.generic?.[filterName];
        const retFilterObj = {
            table: tabObj?.table,
            column: tabObj?.column
        }
        // 
        return retFilterObj;
    }

    const generatePageFilters = (page: any, reportName: string, tabName: string, isDetailedReport: boolean) => {
        const listOfFilters = Object.keys(defaultVariable.powerBiCommonFiltersMap)
            .filter((key: any) => filterValues?.[defaultVariable.powerBiCommonFiltersMap[key]]?.length) //exclude blank filters
            .map((validObj: any) => { //Filters without any values won't be passed
                const filter: models.IBasicFilter = {
                    $schema: "https://powerbi.com/product/schema#basic",
                    filterType: models?.FilterType?.Basic,
                    target: getFilterParams(page, validObj, reportName, tabName, isDetailedReport),
                    operator: "In",
                    values: filterValues?.[defaultVariable.powerBiCommonFiltersMap[validObj]] || [],
                };
                return filter;
            })

        return listOfFilters;
    }

    const eventHandlersMap = new Map([
        [
            "loaded",
            function () {
                console.info("Report has loaded");
                setLoadingPage(false);
            },
        ],
        [
            "rendered",
            function () {
                console.info("Report has rendered");
            },
        ],
        [
            "pageChanged",
            async function (event: any) {
                let page = event.detail.newPage;
                window.scrollTo({
                    top: 0,
                    left: 0,
                });
                console.info(page?.displayName)
                const reportWidth = page?.report?.iframe?.offsetWidth;
                const pageRatio = getAspectRatio(page.displayName);
                const tabName = page.displayName.split("#").pop();
                const isDetailedReport = page.displayName.startsWith(POWERBI_DETAILAED_REPORT_PREFIX);
                isDetailedReport && dispatch(setPowerBiReportPage(POWERBI_DETAILAED_REPORT_NAME));
                setPageAspectRatio(pageRatio);
                let settings = {
                    layoutType: models?.LayoutType.Custom,
                    customLayout: {
                        pageSize: {
                            type: models?.PageSizeType.Custom,
                            width: reportWidth,
                            height: width / pageRatio,
                        },
                        displayOption: models?.DisplayOption.FitToPage
                    }
                };
                const pageLevelFilters = generatePageFilters(page, reportName, tabName, isDetailedReport);
                try {
                    if (!(reportName === 'stationusage' && !isDetailedReport)) {
                        await page?.updateFilters(models.FiltersOperations.Add, pageLevelFilters);
                        await report?.updateSettings(settings);
                    }
                    console.info("Report setttings updated");
                }
                catch (errors) {
                    console.error(errors);
                }
            },
        ],
        [
            "error",
            function (event: any) {
                if (event) {
                    console.error(event.detail);
                }
            },
        ],
    ]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            window.requestAnimationFrame(() => setWidth(event[0].contentBoxSize[0].inlineSize));
        });
    
        if (ref) {
          resizeObserver.observe(ref.current as Element);
        }
      }, [ref]);

    useEffect(() => {
        const setPage = async (pageName = '') => {
            try {
                await report && report?.setPage(pageName);
            } catch (errors) {
                console.error(errors);
            }
        }
        if (report && powerBiReportPage === '' && reportName) {
            setPage((reportName === 'stationusage') ? powerBiStationUsageReportsName?.[reportName] : analyticsReportsNames?.[reportName])
        }
    }, [powerBiReportPage,report,analyticsReportsNames,reportName,powerBiStationUsageReportsName])
    
    useEffect(() => {
        refreshTimer.current = setInterval(()=>{
                checkTokenAndUpdate()
            }, defaultVariable.POWERBI_INTERVAL_TIME)
            return()=>clearInterval(refreshTimer.current)
      }, [])

    useEffect(() => {
        if (!reportName) return;
        dispatch(setPowerBiReportPage(reportName));

        postMethodThirdParty(ApiEndPoint.powerBiAccessToken, '', tokenRequestBody)
            .then((res:any) => {
                if (res?.status === 200) {
                    if (res.data) {
                        sessionStorage.setItem(defaultVariable.POWERBI_EXPIRY_EPOC, res.data?.expiration?.toString());
                        const embedUrl: string = res.data?.value?.find((rId:any) => rId.id === reportId)?.embedUrl || "";
                        setReportConfig({
                            ...reportConfigDefaults,
                            embedUrl: embedUrl,
                            accessToken: res.data?.token,
                        });
                    }
                }
            })
            .catch((err:any) => {
                console.error("Error", err);
            });
    }, [reportName])
    
    return (
        <>
            <div className="powerbi_wrapper_content">
            <main className={reportName === 'dashboard' ? "report-dashboard-main" : classes.content} data-testid="powerbi-component">
                    {/* <DisplaySize width={width} height={height} /> */}
                    <div className='powerbi-page' ref={ref} style={{height: loadingPage ? 800 : Math.ceil(width / pageAspectRatio) + trialBannerHeight}}> 
                        <div>
                            {loadingPage && <SkeletonDashboardReport />}
                            <div style={{ opacity: loadingPage ? "0" : "1" }}>
                                <div className="banner-hider"></div>
                                {reportConfig?.embedUrl && (
                                    <PowerBIEmbed
                                        embedConfig={reportConfig}
                                        eventHandlers={eventHandlersMap}
                                        cssClassName={"report-style-class"}
                                        getEmbeddedComponent={(
                                            reportObject: any
                                        ) => {
                                            setReport(reportObject);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
            </main>
            </div>
        </>
    );
}

export default PowerBiReport;
